export default __webpack_public_path__ + "static/N0308-9e42e286c793d0fea53172d59e67e233.png";